import { render, staticRenderFns } from "./WDGLoader.vue?vue&type=template&id=562579b1&"
import script from "./WDGLoader.vue?vue&type=script&lang=js&"
export * from "./WDGLoader.vue?vue&type=script&lang=js&"
import style0 from "./WDGLoader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../prospect-setup/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports